"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIReleaseNotes = void 0;
const irelease_note_file_1 = require("./irelease-note-file");
const iservice_versions_1 = require("./iservice-versions");
function parseIReleaseNotes(data) {
    if (data.services !== null && typeof data.services === 'object')
        data.services = (0, iservice_versions_1.parseIServiceVersions)(data.services);
    if (data.notes !== null && typeof data.notes === 'object')
        data.notes = data.notes.map((x) => (0, irelease_note_file_1.parseIReleaseNoteFile)(x));
    return data;
}
exports.parseIReleaseNotes = parseIReleaseNotes;
